import React, { Component } from 'react'
import { Layout, Breadcrumb } from 'antd'
import './DPLscreening.scss'
import { withRouter } from 'react-router-dom'
import DPLscreeningTable from '../../components/DPLscreeningTable/DPLscreeningTable'
const { Content } = Layout

class DPLscreening extends Component {
  render() {
    return (
      <div className="CatalogManagementStyles">
        <Layout className="site-layout">
          <Content>
            <div className="layout_middel_content">
              <Breadcrumb>
                <Breadcrumb.Item>DPL SCreening Logs</Breadcrumb.Item>
                <Breadcrumb.Item>List</Breadcrumb.Item>
              </Breadcrumb>
              <DPLscreeningTable history={this.props.history} />
            </div>
          </Content>
        </Layout>
      </div>
    )
  }
}

export default withRouter(DPLscreening)
